import { Defect } from '../service-case/model/defect';
import { ValueUpdater } from '../valueUpdater';
import { DefectV10 } from './v10/case/model/defectV10';
import { DefectV11 } from './v11/service-case/model/defectV11';
export class DefectTransformer {
    static transformList(inVersion, outVersion, payload) {
        const resultList = [];
        payload.forEach((defect) => {
            resultList.push(this.transform(inVersion, outVersion, defect));
        });
        return resultList;
    }
    static transform(inVersion, outVersion, payload) {
        const transformation = inVersion + '-to-' + outVersion;
        switch (transformation) {
            case '12-to-10':
                return this.transformFromV12ToV10(payload);
            case '12-to-11':
                return Defect.constructFromPlainObject(payload);
            case '10-to-12':
                return this.transformFromV10ToV12(payload);
            case '11-to-12':
                return DefectV11.constructFromPlainObject(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
    static transformFromV12ToV10(payload) {
        const defect = Defect.constructFromPlainObject(payload);
        const defectV10 = new DefectV10(defect.getCode(), defect.getDescription(), defect.getType());
        defectV10.setPositionNumber(ValueUpdater.updateNonNullableNumberOrUnknown(defectV10.getPositionNumber(), defect.getPositionNumber()));
        defectV10.setSelected(ValueUpdater.updateNonNullableField(defectV10.isSelected(), defect.getIsSelected()));
        return defectV10;
    }
    static transformFromV10ToV12(payload) {
        const defectV10 = DefectV10.constructFromPlainObject(payload);
        const defect = new Defect(defectV10.getCode(), defectV10.getDescription(), defectV10.getType());
        defect.setPositionNumber(ValueUpdater.updateNullableField(defect.getPositionNumber(), defectV10.getPositionNumber()));
        defect.setIsSelected(ValueUpdater.updateNonNullableField(defect.getIsSelected(), defectV10.isSelected()));
        return defect;
    }
}
//# sourceMappingURL=defectTransformer.js.map